import styled from 'styled-components/macro';
// import { colors } from 'styles/shared.styles';

export const NotFoundContainer = styled.div`
  flex-direction: column;
  line-height: 2;
`;
